// src/pages/AboutPage.tsx
import React from 'react';
import Header from '../components/Header';
import About from '../components/About';
import Footer from '../components/Footer';

const AboutPage: React.FC = () => (
  <div className="min-h-screen w-full bg-gradient-to-br from-slate-900 via-amber-900 to-orange-900 text-white">
    <Header />
    <main className="min-h-screen w-full">
      <About />
    </main>
    <Footer />
  </div>
);

export default AboutPage;
